// React
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// material-ui
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import CircularProgress from '@material-ui/core/CircularProgress';
import BigIconFieldReadOnly from '../../../../../components/BigIconFieldReadOnly/BigIconFieldReadOnly';
import IconTextField from '../../../../../components/Fields/IconTextField/IconTextField';
import BaseDialog from '../../../../../components/BaseDialog/BaseDialog';
import ConfirmationDialog from '../../../../../components/ConfirmationDialog/ConfirmationDialog';
import ConfirmationTermsDialog from '../../../../../components/ConfirmationTermsDialog/ConfirmationTermsDialog';
import ErrorDialog from '../../../../../components/ErrorDialog/ErrorDialog';
import BlockModal from '../../../../../components/BlockModal/BlockModal';
import AssignmentIcon from '@material-ui/icons/AssignmentOutlined';
import PersonIcon from '@material-ui/icons/PersonOutlined';
import AccountIcon from '@material-ui/icons/AccountBalanceOutlined';
import EditIcon from '@material-ui/icons/Edit';
import { isEqual } from 'lodash-es';
import { object, string } from 'yup';
import NZBankValidator from '@fnzc/nz-bank-account-validator';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { Formik, Field } from 'formik';

// Helpers
import {
  getString,
  stringToDate,
} from '../../../../../helpers/stringHelpers.js';

// Styles
import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

const stringsComponent = 'bankDetails';

class BankDetailsDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      requests: [],
      bankNameFromCode: null,
      confirmOpen: false,
      confirmTermsOpen: false,
      isLoading: false,
      hasError: false,
      blockModalOpen: false,
      dirty: false,
    };
    this.initialState = this.state;
    this.handleNext = this.handleNext.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleConfirmTerms = this.handleConfirmTerms.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleBlockModalCancel = this.handleBlockModalCancel.bind(this);
    this.handleBlockModalConfirm = this.handleBlockModalConfirm.bind(this);
  }

  handleNext() {
    this.setState({
      confirmOpen: !this.state.confirmOpen,
    });
  }

  handleConfirm() {
    this.setState({
      confirmTermsOpen: !this.state.confirmTermsOpen,
      confirmOpen: !this.state.confirmOpen,
    });
  }

  handleConfirmTerms(data) {
    const {
      setUnsaved,
      tenancyRef,
      unload,
      confirmed,
      updateBankAccount,
      createBankAccount,
    } = this.props;

    //setUnsaved(false);

    const bankdDetailsData = {
      accountNumber: data.accountNumber,
      tenancyRef: tenancyRef,
    };
    const { accountId } = data;

    if (accountId) {
      updateBankAccount(accountId, bankdDetailsData);
    } else {
      createBankAccount(bankdDetailsData);
    }
  }

  handleCancel() {
    const { cancelAction } = this.props;
    const { dirty } = this.state;

    if (dirty) {
      this.setState({
        blockModalOpen: true,
      });
    } else {
      cancelAction();
    }
  }

  handleBlockModalCancel() {
    this.setState({
      blockModalOpen: false,
    });
  }

  handleBlockModalConfirm() {
    const { cancelAction } = this.props;

    this.setState({ blockModalOpen: false });
    cancelAction();
  }

  setBankName(bankCode, branchCode) {
    let name;
    switch (bankCode) {
      case '01':
        name = 'ANZ';
        break;
      case '02':
        const branchCodeNumber = parseInt(branchCode);
        if (
          branchCodeNumber == 1242 ||
          (branchCodeNumber >= 1245 && branchCodeNumber <= 1250)
        ) {
          name = 'The Co-operative Bank';
        } else {
          name = 'BNZ';
        }
        break;
      case '03':
      case '13':
      case '14':
      case '16':
      case '17':
      case '18':
      case '19':
      case '20':
      case '21':
      case '22':
      case '23':
        name = 'Westpac';
        break;
      case '06':
        name = 'ANZ';
        break;
      case '12':
        name = 'ASB';
        break;
      case '15':
        name = 'TSB';
        break;
      case '25':
        name = 'ANZ';
        break;
      case '30':
        name = 'HSBC';
        break;
      case '31':
        name = 'Citibank';
        break;
      case '38':
        name = 'Kiwibank';
        break;
      default:
        name = null;
    }
    this.setState({
      bankNameFromCode: name,
    });
    return name;
  }

  validateBankNumber(bankNumber) {
    const {
      data: { accountNumber },
    } = this.props;

    const { bankNameFromCode } = this.state;

    this.setState({
      dirty: accountNumber != bankNumber && bankNumber != '0',
    });

    const parts = bankNumber.split('-');
    if (parts.length == 4) {
      return (
        bankNameFromCode !== null &&
        NZBankValidator.isValidNZBankNumber(
          parts[0],
          parts[1],
          parts[2],
          parts[3]
        )
      );
    }
  }

  render() {
    const {
      classes,
      data: { accountId, accountName, bankName, accountNumber },
      cancelAction,
      customerName,
      onError,
      failureText,
      confirmedOpen,
      open,
      theme,
    } = this.props;

    const {
      bankNameFromCode,
      confirmOpen,
      confirmTermsOpen,
      hasError,
      blockModalOpen,
    } = this.state;

    const validationSchema = object().shape({
      accountNumber: string()
        .required(getString(stringsComponent, 'ERROR_MISSING'))
        .matches(
          /^(\d{2})[\D^](\d{4})?[\D^](\d{7})[\D^](\d{2,3})$/,
          getString(stringsComponent, 'ERROR_INVALID_NUMBERS')
        )
        .test(
          'valid-suffix',
          getString(stringsComponent, 'ERROR_INVALID'),
          (bankNumber) => {
            return this.validateBankNumber(bankNumber);
          }
        ),
    });

    return (
      <div>
        <Dialog open={open}>
          <DialogTitle className={classes.title}>
            <div className={classes.heading}>
              <EditIcon className={classes.avatar} />
              <Typography variant="h3">
                {getString(stringsComponent, 'EDIT_DETAILS_TITLE')}
              </Typography>
            </div>
          </DialogTitle>
          <Divider />
          <br />
          <DialogContent>
            <Modal
              open={this.state.isLoading}
              disableAutoFocus={true}
              className={classes.modal}
            >
              <CircularProgress size={50} className={classes.progress} />
            </Modal>
            {hasError && <ErrorDialog logout={onError} text={failureText} />}
            <Card className={classes.card}>
              <CardContent>
                <Formik
                  initialValues={{
                    accountId: accountId,
                    accountName: accountName ? accountName : customerName,
                    accountNumber: accountNumber,
                  }}
                  isInitialValid={true}
                  onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    this.handleNext();
                  }}
                  validationSchema={validationSchema}
                >
                  {(props) => {
                    const {
                      values,
                      handleSubmit,
                      isValid,
                      setFieldValue,
                      initialValues,
                      errors,
                    } = props;

                    let fields = [];
                    values.accountName != initialValues.accountName &&
                      fields.push({
                        label: getString(
                          stringsComponent,
                          'ACCOUNT_NAME_LABEL'
                        ),
                        value: values.accountName,
                      });
                    values.accountNumber != initialValues.accountNumber &&
                      fields.push({
                        label: getString(
                          stringsComponent,
                          'ACCOUNT_NUMBER_LABEL'
                        ),
                        value: values.accountNumber,
                      });
                    bankNameFromCode &&
                      bankNameFromCode != bankName &&
                      fields.push({
                        label: getString(stringsComponent, 'BANK_NAME_LABEL'),
                        value: bankNameFromCode,
                      });

                    return (
                      <form
                        onChange={() => {
                          //setUnsaved(true);
                        }}
                      >
                        <ConfirmationDialog
                          cancel={this.handleNext}
                          confirm={() => {
                            this.handleConfirm();
                          }}
                          open={confirmOpen}
                          dialogText={getString(
                            stringsComponent,
                            'CHANGES_TEXT'
                          )}
                          submitLabel={getString(
                            stringsComponent,
                            'NEXT_LABEL'
                          )}
                          fields={fields}
                        />
                        <ConfirmationTermsDialog
                          cancel={this.handleConfirm}
                          confirm={() => {
                            this.handleConfirmTerms(values);
                          }}
                          open={confirmTermsOpen}
                        />
                        <Grid container spacing={16}>
                          <Grid item xs={12}>
                            <IconTextField
                              id={'accountName'}
                              icon={null}
                              iconColour={theme.palette.custom.accounts}
                              label={getString(
                                stringsComponent,
                                'ACCOUNT_NAME_LABEL'
                              )}
                              value={values.accountName}
                              formik={true}
                              disabled={true}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <IconTextField
                              id={'accountNumber'}
                              icon={null}
                              iconColour={theme.palette.custom.accounts}
                              label={getString(
                                stringsComponent,
                                'ACCOUNT_NUMBER_LABEL'
                              )}
                              value={values.accountNumber}
                              placeholder={'e.g. 00-0000-0000000-00'}
                              formik={true}
                              maxLength={19}
                              clear={() => {
                                setFieldValue('accountNumber', '');
                              }}
                              autoFocus={true}
                              error={Boolean(errors.accountNumber)}
                              helpText={errors.accountNumber}
                              onKeyUp={(event) => {
                                // Only apply formatting if the backspace key is not used.
                                // This is to make it easier to delete parts of the number.
                                if (event.keyCode !== 8) {
                                  setFieldValue(
                                    'accountNumber',
                                    values.accountNumber.replace(
                                      /(\d{2})[\D^]?(\d{4})?[\D^]?(\d{7})?[\D^]?(\d{2,3})?/,
                                      (match, p1, p2, p3, p4) => {
                                        // Format bank account number in the format:
                                        // 00-0000-0000000-00
                                        let formatted = '';
                                        const groups = [p1, p2, p3, p4];
                                        groups.forEach((val, key, arr) => {
                                          formatted += val
                                            ? key === arr.length - 1
                                              ? val + ''
                                              : val + '-'
                                            : '';
                                        });
                                        return formatted;
                                      }
                                    )
                                  );
                                }
                                this.setBankName(
                                  values.accountNumber.substring(0, 2),
                                  values.accountNumber.substring(3, 7)
                                );
                              }}
                              onBlur={() => {
                                const accountNumber = values.accountNumber;
                                if (!errors.accountNumber) {
                                  // If account number is valid, ensure that the
                                  // suffix is 3 digits long.
                                  let suffix = accountNumber.slice(
                                    accountNumber.length - 3
                                  );
                                  if (!suffix.match(/^[0-9]+$/)) {
                                    suffix = suffix.slice(suffix.length - 2);
                                    setFieldValue(
                                      'accountNumber',
                                      accountNumber.substring(0, 16) +
                                        '0' +
                                        suffix
                                    );
                                  }
                                }
                              }}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <IconTextField
                              id={'bankName'}
                              icon={null}
                              iconColour={theme.palette.custom.accounts}
                              label={getString(
                                stringsComponent,
                                'BANK_NAME_LABEL'
                              )}
                              value={
                                bankNameFromCode ? bankNameFromCode : bankName
                              }
                              formik={true}
                              disabled={true}
                            />
                          </Grid>
                        </Grid>
                        <div className={classes.buttons}>
                          <Button
                            className={`${classes.button} ${classes.buttonOutlined}`}
                            variant="outlined"
                            onClick={this.handleCancel}
                            color="default"
                          >
                            {getString(stringsComponent, 'CANCEL_LABEL')}
                          </Button>
                          <Button
                            variant="outlined"
                            color="primary"
                            className={`${classes.button} ${classes.buttonSubmit}`}
                            onClick={handleSubmit}
                            disabled={
                              isEqual(initialValues, values) ||
                              !isValid ||
                              !bankNameFromCode
                            }
                          >
                            {getString(stringsComponent, 'NEXT_LABEL')}
                          </Button>
                        </div>
                      </form>
                    );
                  }}
                </Formik>
              </CardContent>
            </Card>
          </DialogContent>
        </Dialog>
        <BlockModal
          show={blockModalOpen}
          message={getString('blockModal', 'MESSAGE')}
          cancel={this.handleBlockModalCancel}
          ok={this.handleBlockModalConfirm}
          secondaryButtonLabel={getString('blockModal', 'BUTTON_LABEL_CANCEL')}
        />
      </div>
    );
  }
}

BankDetailsDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  button: PropTypes.object,
  button2: PropTypes.object,
  data: PropTypes.shape({
    accountName: PropTypes.string.isRequired,
    bankName: PropTypes.string.isRequired,
    accountNumber: PropTypes.string.isRequired,
    createdDate: PropTypes.string.isRequired,
  }).isRequired,
  setUnsaved: PropTypes.func.isRequired,
  cancelAction: PropTypes.func.isRequired,
  unload: PropTypes.func.isRequired,
  confirmed: PropTypes.func.isRequired,
  customerName: PropTypes.string.isRequired,
  onError: PropTypes.func.isRequired,
  failureText: PropTypes.object.isRequired,
  postSubmitAction: PropTypes.func.isRequired,
  tenancyRef: PropTypes.string,
};

BankDetailsDialog.defaultProps = {
  data: {
    accountName: '',
    bankName: '',
    accountNumber: '',
    createdDate: '',
  },
  button: null,
  button2: null,
  tenancyRef: null,
};

const mapStateToProps = (state) => ({
  confirmedOpen: state.app.confirmedOpen,
});

export default connect(mapStateToProps)(
  withStyles(styles, { withTheme: true })(BankDetailsDialog)
);
